import { render } from "./legoDropdown.vue?vue&type=template&id=6b562618"
import script from "./legoDropdown.vue?vue&type=script&lang=js"
export * from "./legoDropdown.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/lego-component/components/element/legoDropdown/legoDropdown.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6b562618"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6b562618', __exports__)) {
    api.reload('6b562618', __exports__)
  }
  
  module.hot.accept("./legoDropdown.vue?vue&type=template&id=6b562618", () => {
    api.rerender('6b562618', render)
  })

}


export default __exports__